import React, { useState, useRef } from "react";
import { usePopper } from "react-popper";
import OutsideClickHandler from "react-outside-click-handler";

function DefaultButton(props) {
	return <span className="dots" {...props}>...</span>;
}

export default function Dropdown({ button: Button = DefaultButton, list }) {
	const [visible, setVisible] = useState(false);
	const referenceRef = useRef(null);
	const popperRef = useRef(null);

	const { styles, attributes, update } = usePopper(
		referenceRef.current,
		popperRef.current,
		{
			placement: "bottom",
		}
	);

	const hide = () => setVisible(false);

	function handleDropdownClick(e) {
		e.preventDefault();
		e.stopPropagation();
		setVisible(true);
		if(typeof(update)=== "function") {
			update();  // Fix to update position of popper
		}
	}

	const containerStyle = {
		...styles.popper,
		display: visible ? "flex" : "none",
		zIndex: 999,
	};

	return (
		<React.Fragment>
			<span ref={referenceRef} onClick={handleDropdownClick}>
				<Button />
			</span>
			<div ref={popperRef} style={containerStyle} {...attributes.popper}>
				<OutsideClickHandler onOutsideClick={hide}>
					<div className="eclip-landing-menu ">
						<div className="api-configuration__column__add__cols api-configuration__column__add__cols-popover">
							{list?.filter(item => item !== undefined)?.map((item, index) => (
								<div
									key={index}
									className="eclip-landing__column__add__col link"
									onClick={(e) => { item?.onClick(e); hide(); }}
									style={{
										color: item?.color || "",
									}}
								>
									<span>{item?.label}</span>
								</div>
							))}
						</div>
					</div>
				</OutsideClickHandler>
			</div>
		</React.Fragment>
	);
}
